module.exports = __webpack_public_path__ + "static/scale-model-of-children's-hands-on-museum-in-tuscaloosa-alabama-cebc6ec9a141b0bc5ee8c9a1f0243cff.png";